const createCommissionRule = `
mutation createCommissionRule($input: commissionRuleInput!){
  createCommissionRule(input:$input){
    createdStatus{
      id
    }
    status
    errors
  }
}
`

const addEntityToCommissionRule = `
mutation addEntityToCommissionRule($id: String! $entityId: String!){
  addEntityIdToCommissionRule(id:$id entityId:$entityId){
    status
    errors
  }
}
`

const commissionRules = `
query commissionRules($where: commissionRuleWhereInput $sort:sortInput $skip:Int $limit:Int ){
  commissionRules(where: $where sort:$sort skip:$skip limit:$limit){
    totalCount
    list{
      id
      name
      description
      jsonRule
      createdAt
      createdBy{ associatedUser { id name } }
      lastModifiedAt
      lastModifiedBy{ associatedUser { id name } }
      product{
        name
        productId{
          plan
          type
          version
        }
      }
    }
  }
}
`

const query = {
	commissionRules
}

const mutation = { createCommissionRule, addEntityToCommissionRule }

export { query, mutation }
